
const Data = [
    {
        id: 1,
        category: "education",
        icon: "icon-graduation",
        year: "2020 - present",
        title: "Bachelors of Engineering, Software Engineering",
        desc: "Throughout my degree, I have developed a strong foundation in software architecture, full-stack development, and scalable systems. My coursework has covered a diverse range of topics, including: Software Design & Object-Oriented Programming (OOP), Web Development & Cloud Computing, Databases & SQL, Networking & Cybersecurity, Testing & Automation, Data Structures & Algorithms, Mathematics for Computing. These courses have deepened my expertise in building high-performance applications, securing systems, and automating workflows, fueling my passion for software development and engineering excellence."
    },
    {
        id: 2,
        category: "education",
        icon: "icon-graduation",
        year: "2022 - present",
        title: "Honours in Business Administrations",
        desc: "Through Ivey’s case-based learning methodology, I developed critical thinking, leadership, and strategic decision-making skills by analyzing real-world business challenges. My coursework provided a strong foundation in business fundamentals across multiple disciplines, including: Corporate Financial Accounting, Finance & Investment Analysis, Marketing & Strategy, Leadership & Communication, Technology & Information Systems, Managing High Growth Companies. This program honed my ability to solve complex business problems, communicate effectively, and lead cross-functional teams, complementing my software engineering expertise.",
    },
    {
        id: 3,
        category: "education",
        icon: "icon-graduation",
        year: "2016 - 2020",
        title: "École Secondaire Catholique l'Essor",
        desc: "At l'Essor, I completed a bilingual diploma of the International Baccalaureate program. I recieved a 95% average while starting a new club called Eco Vibrant Essor and playing on the Football and Soccer teams. I earned athlete of the year, captained the soccer team and made the all-start teams for football and soccer in Essex County.",
    },
    {
        id: 4,
        category: "experience",
        icon: "icon-briefcase",
        year: "November 2024 - Present",
        title: "Software Engineer: Flowmatic",
        desc: "Built and deployed an ETL pipeline using Airflow, PostgreSQL, and AWS EC2, improving data processing of over 10,000 customer records. Integrated FastAPI with automated TypeScript type generation, accelerating API development and debugging capabilities. Enhanced backend and frontend synchronization, streamlining data accessibility and system performance.",
    },
    {
        id: 5,
        category: "experience",
        icon: "icon-briefcase",
        year: "Summer 2024",
        title: "Software Engineering Intern: Zynga Games Inc.",
        desc: "Developed and deployed a React, Python, and Airflow-based feature enabling game analysts to segment users and visualize metrics, used in games suchc as Harry Potter and Words With Friends 2. Migrated internal data services, helping in the reduction of costs by $250K annually. Automated Terraform infrastructure and data pipelines using Jenkins and Kubernetes, improving system efficiency.",
    },
    {
        id: 6,
        category: "experience",
        icon: "icon-briefcase",
        year: "November 2023 - March 2024",
        title: "Software Developer: Repwave",
        desc: "Developed and optimized a Flask/Python backend while leading React front-end development for a B2B SaaS product. Integrated APIs to process monthly conversational data, improving efficiency. Collaborated with the design of UI/UX workflows in Figma, enhancing usability and functionality. Collaborated with a Salesforce Senior SWE, refining technical architecture and performance.",
    },
    {
        id: 7,
        category: "experience",
        icon: "icon-briefcase",
        year: "Summer 2023",
        title: "Business Systems Analyst Intern: Ontario Health Digital Services",
        desc: "As a Business Systems Analyst, I implemented Scrum methodologies, increasing sprint velocity by 18% through effective backlog management and team coordination. Led Scrum meetings to streamline project execution. Developed a Microsoft Azure DevOps dashboard with burndown and Gantt charts, enhancing task tracking and client reporting. This experience strengthened my skills in agile project management, data visualization, and stakeholder communication.",
    },
];

export default Data